<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import { userRole, isReadOnly } from '$stores/sessionStore';
    import { refreshCurrentSiteCount } from '$stores/messageCountStore';
    import { refreshCurrentParticipantCount } from '$stores/participantMessageCountStore';
    const dispatch = createEventDispatcher();

    const API_BASE_URL = '/api/proxy';
  
    export let isOpen = false;
    export let title = '';
    export let messageTitle = 'Reminder';
    export let messageText = '';
    export let messageTypeCode = 'MSGREMINDER';

    let messageTypeOptions = [];

    onMount(fetchMessageTypeOptions);

    async function fetchMessageTypeOptions() {
      try {
        const response = await fetch(`${API_BASE_URL}/lookups/MSGTYPE`);
        if (response.ok) {
          const data = await response.json();
          messageTypeOptions = data.data || [];
        }
      } catch (error) {
        console.error('Error fetching message type options:', error);
      }
    }
  
    function handleClose() {
      dispatch('close');
    }
  
    async function handleSubmit() {
      dispatch('submit', { title: messageTitle, message: messageText, messageTypeCode });
      // Refresh the message counts when a new message is created
      try {
        await refreshCurrentSiteCount();
      } catch (error) {
        console.log('Could not refresh site message count:', error.message);
      }
      try {
        await refreshCurrentParticipantCount();
      } catch (error) {
        console.log('Could not refresh participant message count:', error.message);
      }
    }
  </script>
  
  {#if isOpen}
    <div class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
      <div class="modal-overlay absolute inset-0 bg-slate-800 opacity-75" on:click={handleClose}></div>
      <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg max-w-md w-full mx-4 relative z-60">
        <h2 class="text-xl font-bold mb-4 text-gray-900 dark:text-white">{title}</h2>
        <div class="mb-4">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Type
          </label>
          <select
            bind:value={messageTypeCode}
            class="w-full px-3 py-2 border rounded-md bg-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          >
            {#each messageTypeOptions as option}
              <option value={option.code}>{option.label}</option>
            {/each}
          </select>
        </div>
        <div class="mb-4">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Title
          </label>
          <input
            type="text"
            bind:value={messageTitle}
            class="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            placeholder="Enter message title"
          />
        </div>
        <div class="mb-4">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Message
          </label>
          <textarea
            bind:value={messageText}
            class="w-full px-3 py-2 border rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            rows="4"
            placeholder="Enter message content"
          ></textarea>
        </div>
        <div class="flex justify-end gap-2">
          <button
            class="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600"
            on:click={handleClose}
          >
            Cancel
          </button>
          <button
            class="px-4 py-2 bg-green-700 text-white rounded hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed"
            on:click={handleSubmit}
            disabled={isReadOnly()}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  {/if}